import React from "react";
import { useIntl } from "react-intl";

type CustLendItemsProps = {
  handleSelect?: Function;
  items: any[];
};

export default function CustLendItems({
  handleSelect = undefined,
  items = [],
}: CustLendItemsProps) {
  const { formatMessage } = useIntl();

  const handleContinue = (item: any) => {
    if (handleSelect !== undefined && item.iscancontinue) {
      handleSelect(item);
    }
  };

  return (
    <>
      <h4>{formatMessage({ id: "hyvendor.menu.loanlist" })}</h4>
      {false && ( // 關掉功能
        <ul className="status-info">
          <li>{formatMessage({ id: "hyvendor.status.renew" })}</li>
          <li>{formatMessage({ id: "hyvendor.status.unrenewable" })}</li>
        </ul>
      )}
      <div className="scroll">
        {items !== null &&
          items.map((item, i) => {
            return (
              <section
                key={i}
                className={`Item ${
                  item.iscancontinue
                    ? ""
                    : item.overdueday > 0
                    ? "unavailable"
                    : item.continuenum !== 0
                    ? "extension"
                    : "unavailable"
                }`}
              >
                {false && ( // 關掉功能
                  <div className="status" onClick={() => handleContinue(item)}>
                    <span>
                      {item.iscancontinue
                        ? formatMessage({ id: "hyvendor.status.renew" })
                        : item.overdueday > 0
                        ? formatMessage({
                            id: "hyvendor.status.unrenewable",
                          })
                        : item.continuenum !== 0
                        ? formatMessage({ id: "hyvendor.status.renewed" })
                        : formatMessage({
                            id: "hyvendor.status.unrenewable",
                          })}
                    </span>
                  </div>
                )}
                <div className="list">
                  <ul>
                    <li>
                      <p>{item.title}</p>
                      <span className="currently">
                        {item.overdueday > 0 && (
                          <span className="now">
                            {formatMessage({ id: "hyvendor.column.overdue" })}
                            {item.overdueday}
                            {formatMessage({ id: "hyvendor.column.day" })}
                          </span>
                        )}
                        <span className="date">{item.returndate}</span>
                        {formatMessage({ id: "hyvendor.column.duedate" })}
                      </span>
                      <span className="bar-code">
                        {formatMessage({ id: "hyvendor.column.barcode" })}:
                        <span>{item.barcode}</span>
                      </span>
                      <span className="call-number">
                        {formatMessage({ id: "hyvendor.column.callnumber" })}:
                        <span>{item.callnumber}</span>
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
            );
          })}
      </div>
    </>
  );
}
